import ContentContainer from "@/src/components/containers/ContentContainer";
import GenericHead from "@/src/components/Head/GenericHead";

const AboutPage = () => {
  return (
    <>
      <GenericHead title={"About Supercoach playbook"} />
      <div className="bg-white">
        <ContentContainer bgColor="white">
          <div className={"flex flex-col gap-4 py-4 bg-white 123"}>
            <h1>Contact</h1>

            <p>Email: supercoachplaybook@gmail.com</p>

            <p>
              <strong>NRL SOCIAL CHANNELS</strong>
            </p>

            <p>
              Twitter:{" "}
              <a
                href="https://twitter.com/scplaybook1"
                target="_blank"
                rel="noreferrer noopener"
                aria-label=" (opens in a new tab)"
              >
                https://twitter.com/scplaybook1
              </a>
            </p>

            <p>
              Facebook:{" "}
              <a
                href="https://www.facebook.com/scplaybook1"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="(opens in a new tab)"
              >
                https://www.facebook.com/scplaybook1
              </a>
            </p>

            <p>
              Instagram:{" "}
              <a
                rel="noreferrer noopener"
                aria-label=" (opens in a new tab)"
                href="https://www.instagram.com/scplaybook1/"
                target="_blank"
              >
                https://www.instagram.com/scplaybook1/
              </a>
            </p>

            <p>
              TikTok:{" "}
              <a
                rel="noreferrer noopener"
                href="https://www.tiktok.com/@scplaybooknrl"
                target="_blank"
              >
                https://www.tiktok.com/@scplaybooknrl
              </a>
            </p>

            <p>
              YouTube:{" "}
              <a
                rel="noreferrer noopener"
                href="https://www.youtube.com/channel/UCMReymNfmodE1OEc9fQvwQQ"
                target="_blank"
              >
                https://www.youtube.com/channel/UCMReymNfmodE1OEc9fQvwQQ
              </a>
            </p>

            <p>
              <strong>AFL SOCIAL CHANNELS</strong>
            </p>

            <p>
              Twitter:{" "}
              <a
                href="https://twitter.com/scplaybookafl"
                target="_blank"
                rel="noreferrer noopener"
              >
                https://twitter.com/scplaybookafl
              </a>
            </p>

            <p>
              Facebook:{" "}
              <a
                rel="noreferrer noopener"
                href="https://www.facebook.com/scplaybookafl"
                target="_blank"
              >
                https://www.facebook.com/scplaybookafl
              </a>
            </p>

            <p>
              Instagram:{" "}
              <a
                href="https://www.instagram.com/scplaybookafl/"
                target="_blank"
                rel="noreferrer noopener"
              >
                https://www.instagram.com/scplaybookafl/
              </a>
            </p>

            <p>
              TikTok:{" "}
              <a
                rel="noreferrer noopener"
                href="https://www.tiktok.com/@scplaybookafl"
                target="_blank"
              >
                https://www.tiktok.com/@scplaybookafl
              </a>
            </p>

            <p>
              <strong>CRICKET SOCIAL CHANNELS</strong>
            </p>

            <p>
              Twitter:{" "}
              <a
                rel="noreferrer noopener"
                href="https://twitter.com/scplaybookbbl"
                target="_blank"
              >
                https://twitter.com/scplaybook
              </a>
              <a
                href="https://twitter.com/scplaybookbbl"
                target="_blank"
                rel="noreferrer noopener"
              >
                cric
              </a>
            </p>

            <p>
              Facebook:
              <a
                href="https://www.facebook.com/scplaybookbbl"
                target="_blank"
                rel="noreferrer noopener"
              >
                {" "}
                https://www.facebook.com/scplaybookbbl
              </a>
            </p>

            <p>
              Instagram:
              <a
                rel="noreferrer noopener"
                href="https://www.instagram.com/scplaybookbbl/"
                target="_blank"
              >
                {" "}
                https://www.instagram.com/scplaybook
              </a>
              <a
                href="https://www.instagram.com/scplaybookcricket/"
                target="_blank"
                rel="noreferrer noopener"
              >
                cricket
              </a>
            </p>

            <p>
              TikTok:{" "}
              <a
                href="https://www.tiktok.com/@scplaybookcricket"
                target="_blank"
                rel="noreferrer noopener"
              >
                https://www.tiktok.com/@scplaybookcricket
              </a>
            </p>
          </div>
        </ContentContainer>
      </div>
    </>
  );
};

export default AboutPage;
